import React, { CSSProperties, createRef } from "react";
import { Link } from "react-router-dom";
import { IListObj } from "../types/genericTypes";
import "../../assets/scss/components/generic/tab.scss";

export interface ITabProps {
	defaultValue?: number | string; // default selected value
	tabList: Array<IListObj>; // list of all options in list
	position: "left" | "center"; // position where the tabs should be present
	onSelect?: (id: string | number) => void; // the function to be called onSelect
}

export interface ITabState {
	selectedValue?: number | string; // current selected value
	blueBarStyle: CSSProperties; // style for blueBar
}

class Tab extends React.Component<ITabProps, ITabState> {
	secNavigationRef: React.RefObject<HTMLUListElement>;

	constructor(props: ITabProps) {
		super(props);
		this.state = {
			selectedValue: this.props.defaultValue,
			blueBarStyle: {} as CSSProperties
		};
		this.secNavigationRef = createRef();

		window.onload = () => {
			this.makeTabUnderline();
		};
	}

	makeTabUnderline() {
		const RefEle = this.secNavigationRef.current?.getElementsByClassName(`${this.props.defaultValue}`)[0] as HTMLLIElement;
		if (RefEle) {
			const { offsetWidth, offsetLeft } = RefEle as HTMLLIElement;
			this.setState({ blueBarStyle: { width: offsetWidth, left: offsetLeft } });
		}
	}

	tabSelected = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, id: number | string) => {
		const { offsetWidth, offsetLeft } = e.target as HTMLLIElement;
		this.setState({ blueBarStyle: { width: offsetWidth, left: offsetLeft } });
		this.setState({ selectedValue: id });
		if (this.props.onSelect) {
			this.props.onSelect(id);
		}
	};

	componentDidMount() {
		this.makeTabUnderline();
	}

	render() {
		return (
			<ul className={"sec_navigation_tablet" + (this.props.position === "left" ? " taLeft" : " taCenter")} ref={this.secNavigationRef}>
				{this.props.tabList.map((tab, index) => (
					<li
						key={tab.value}
						className={`tab${index !== this.props.tabList.length - 1 ? " mg-r25" : ""} ${tab.value}${
							tab.value === this.state.selectedValue ? " active" : ""
						}`}
						onClick={(e) => this.tabSelected(e, tab.value)}
					>
						{tab.href && <Link to={tab.href}>{tab.display}</Link>}
						{!tab.href && tab.display}
					</li>
				))}
				<span className="blue_bar" style={this.state.blueBarStyle}></span>
			</ul>
		);
	}
}

export default Tab;
